import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    collapse: {
      type: Boolean,
      default() {
        return false;
      }
    },
    fixedHeader: {
      type: Boolean,
      default() {
        return true;
      }
    },
    showTabs: {
      type: Boolean,
      default() {
        return true;
      }
    },
    device: {
      type: String,
      default() {
        return 'desktop';
      }
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_vab_header = _resolveComponent("vab-header");
      const _component_vab_side_bar = _resolveComponent("vab-side-bar");
      const _component_vab_tabs = _resolveComponent("vab-tabs");
      const _component_vab_app_main = _resolveComponent("vab-app-main");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["vab-layout-common", {
          fixed: __props.fixedHeader,
          'no-tabs-bar': !__props.showTabs
        }])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["vab-layout-header", {
          'fixed-header': __props.fixedHeader
        }])
      }, [_createVNode(_component_vab_header, {
        layout: "common"
      }), _createElementVNode("div", null, [_createVNode(_component_vab_side_bar, {
        layout: "common"
      }), _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["vab-main", {
          'is-collapse-main': __props.collapse
        }])
      }, [_createVNode(_component_vab_tabs, {
        layout: "common"
      })], 2), [[_vShow, __props.showTabs]])])], 2), _createElementVNode("div", {
        class: _normalizeClass(["vab-main main-padding", {
          'is-collapse-main': __props.collapse
        }])
      }, [_createVNode(_component_vab_app_main)], 2)], 2);
    };
  }
});